import { AbstractControl, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, filter, tap } from 'rxjs/operators';
import { City, Province } from '@lemsar/common/domains/models/addressing';
import { ProvinceService } from '@lemsar/common/domains/services/province.service';
import { HomeParameter } from '@lemsar/home/views/containers/home.container';
import { CityService } from '@lemsar/common/domains/services/city.service';

@Component({
    selector: 'lemsar-filter-container',
    templateUrl: './filter.container.html',
})
export class FilterContainer implements OnInit {
    public filterInstitution: { text: string; value: string }[] = [
        { text: 'Semua Lembaga', value: '' },
        { text: 'Mitra Kartu Prakerja', value: 'pre_work_card' },
        { text: 'Mitra JKP', value: 'jkp' },
        { text: 'Pemerintah', value: 'government' },
        { text: 'Swasta', value: 'private' },
        { text: 'Industri', value: 'industrial' },
        { text: 'BLK Komunitas', value: 'community' },
    ];

    public filterProvince: Province[] = [{ id: '', name: 'Semua Provinsi' }];

    public filterCity: City[] = [{ id: '', name: 'Semua Kota', district: false, province: null }];

    public parameter: HomeParameter = {
        type: '',
        province: '',
        city: '',
        name: '',
    };

    public searchControl: AbstractControl = new FormControl('');

    public search = '';
    public type = '';
    public province = '';
    public city = '';

    public constructor(
        private router: Router,
        private route: ActivatedRoute,
        private provinceService: ProvinceService,
        private cityService: CityService,
    ) {}

    public ngOnInit() {
        this.provinceService.fetchAllProvinces().subscribe((data: Province[]) => (this.filterProvince = [...this.filterProvince, ...data]));

        this.route.queryParams
            .pipe(
                tap((params: any) => {
                    if (params.name) {
                        this.searchControl.setValue(params.name);
                    }
                    if (params.type) {
                        this.type = Array.isArray(params.type) ? params.type[0] : params.type;
                    }
                    if (params.province) {
                        this.province = params.province;
                    }
                    if (params.city) {
                        this.city = params.city;
                    }
                }),
            )
            .subscribe((params: any) => {
                this.parameter = Object.assign(this.parameter, params);
                this.fetchCityData();
            });

        this.searchControl.valueChanges
            .pipe(
                // distinctUntilChanged(),
                debounceTime(2000),
                filter((name: string) => name.length >= 3 || name.length === 0),
            )
            .subscribe((res: string) => this.setQueryParams({ name: res }));
    }

    // public setView(view: string): void {
    //     this.views = view;
    //     this.setQueryParams({ view: this.views });
    // }

    public fetchCityData() {
        if (this.parameter.province) {
            this.cityService.fetchCitiesByProvince(this.parameter.province).subscribe((data: City[]) => (this.filterCity = [...data]));
        } else {
            this.cityService
                .fetchAllCities()
                .subscribe(
                    (data: City[]) => (this.filterCity = [{ id: '', name: 'Semua Kota', district: false, province: null }, ...data]),
                );
        }
    }

    public setQueryParams(params: any) {
        this.parameter = Object.assign(this.parameter, params);
        this.parameter.page = 1;

        this.fetchCityData();

        this.router.navigate(['.'], {
            queryParams: this.parameter,
            queryParamsHandling: 'merge',
        });
    }

    public getFilterClass() {
        return {
            info: 'government' === this.type,
            warning: 'private' === this.type,
            success: 'industrial' === this.type,
            secondary: 'community' === this.type,
        };
    }
}



// WEBPACK FOOTER //
// ./apps/frontend/src/template/default/containers/filter.container.ts